import { register } from "async-ops";
import { callMvcApi } from "../../../../call-web-api";
export const GET_TOP_FIVE_PROVIDER_LIST = "GET_TOP_FIVE_PROVIDER_LIST";

export const service = async (data) => {  
  data.limit="5"
  const options: object = {
    url: "/api/DenialsPredictor/GetTopFiveProviderList",
    method: "POST",
    headers: {
      "Content-Type": "application/json",},
    body: JSON.stringify(data),
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_TOP_FIVE_PROVIDER_LIST, service, mock);
  